/**
 * Page Performance — which API call replies count as FAILED (pure, no
 * React/DOM imports). The server keeps the same rule in
 * page-performance.util.js (`isFailedStatus`).
 */

/**
 * A call FAILED only when the server could not serve it: a server error
 * (5xx), a timeout (408), too many requests (429) or no reply (status 0 — a
 * network error, or a timeout with no response) — a permission or not-found
 * reply (403, 404 …) does not count, nor does any other 4xx (400, 401, 409,
 * 422 …): the server answered correctly, and such a reply is often expected
 * (a page asks, then shows "not available for your role"). A missing or
 * non-numeric status counts as no reply, like 0.
 */
export function isFailedStatus(status) {
  const s = Number(status)
  if (!Number.isFinite(s) || s <= 0) return true
  return s >= 500 || s === 408 || s === 429
}
